import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    fallbackLng: {
      'en-US': ['en'],
      default: ['en'],
    },
    load: 'languageOnly',
    // Fetched together at startup (about 12 KB gzipped per language). Left to load on first use,
    // each namespace suspends in turn (the page's `app`, then the sider's `help`, then the account
    // menu's `auth`/`error`): one round trip after another before the first paint.
    ns: ['translation', 'app', 'auth', 'error', 'help'],
  });

export default i18n;
